var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptIconBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5617 34.0936H34.0937V38.5617C34.0937 42.4811 38.88 44.5529 41.7155 41.7156C44.5529 38.88 42.481 34.0936 38.5617 34.0936ZM6.4381 32.127H10.9061V12.8717H6.4381C0.773047 12.8717 -2.17946 5.96461 1.89396 1.89267C5.96553 -2.17902 12.8726 0.771727 12.8726 6.43895V10.9071H32.1274V6.43895C32.1274 0.771727 39.0343 -2.17887 43.1061 1.89267C47.1776 5.96631 44.227 12.8717 38.5619 12.8717H34.0939V32.127H38.5619C44.229 32.127 47.1795 39.0341 43.1061 43.106C39.0345 47.1777 32.1274 44.227 32.1274 38.5617V34.0936H12.8726V38.5617C12.8726 44.229 5.96578 47.1796 1.89396 43.106C-2.17956 39.0343 0.771097 32.127 6.4381 32.127ZM10.9061 34.0936H6.4381C2.51886 34.0936 0.447101 38.88 3.28433 41.7155C6.1198 44.553 10.9061 42.481 10.9061 38.5616L10.9041 34.0935L10.9061 34.0936ZM6.4381 10.9052H10.9061V6.4371C10.9061 2.51574 6.1198 0.445922 3.28438 3.28323C0.446951 6.11879 2.51686 10.9052 6.4381 10.9052ZM34.0935 10.9052H38.5615C42.4807 10.9052 44.5525 6.11879 41.7153 3.28328C38.8798 0.445772 34.0935 2.51779 34.0935 6.43715L34.0935 10.9052ZM32.127 12.8718H12.8722V32.1271H32.127V12.8718Z",
    fill: "#678097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIconBanner);
export default __webpack_public_path__ + "static/media/promptIconBanner.7f818aa39fef1feaf763c7646ae84136.svg";
export { ForwardRef as ReactComponent };